import script from "./NewUserPage.vue?vue&type=script&setup=true&lang=js"
export * from "./NewUserPage.vue?vue&type=script&setup=true&lang=js"

import "./NewUserPage.vue?vue&type=style&index=0&id=9d269cb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d269cb6"]])

export default __exports__